import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';

@OpenApiMethod({
  method: HttpMethods.DELETE,
  apiName: 'customer',
  path: '/auth/clear-anonymous-users',
  operationId: 'AuthController_clearAnonymousUsers',
  parameters: [],
})
export class AuthControllerClearAnonymousUsersMethod extends BaseOpenApiMethod<void> implements Method<void, void> {
  public call(): Promise<void> {
    return super.call();
  }
}
